export function getResponseStatus(error: Response): string {
  if (!navigator.onLine) {
    return 'offLine';
  }

  if (error.status === 401) {
    if (error.statusText === 'UNAUTHORIZED_IP') {
      return 'unauthorizedIP';
    }

    return 'unknownLoginPassword';
  }

  if (error.status === 400) {
    return 'disabledAccount';
  }

  return 'unreachableServer';
}

export const statusDescription = {
  offLine: 'Erreur : Pas de connexion réseau.',
  unreachableServer: 'Erreur : Impossible de contacter le serveur.',
  unknownLoginPassword: 'Erreur : Email ou mot de passe incorrects.',
  unauthorizedIP:
    'Erreur : Votre adresse IP actuelle n’est pas autorisée à se connecter. Veuillez vous connecter depuis votre réseau professionnel.',
  loginSchemeError:
    "Erreur : Impossible de récupérer la méthode d'authentification.",
  resetPasswordEmailSent:
    'Un mail vous a été envoyé : il contient un lien temporaire pour vous connecter et choisir un nouveau mot de passe.',
  resetPasswordUnknownLogin:
    "Erreur : L'adresse mail ne correspond à aucun utilisateur connu.",
  signupError: 'Erreur lors de la tentative de création du compte.',
  unknownSamlConnection: (
    <>
      <p>
        {"Erreur : votre annuaire d'entreprise n'est pas reconnu par Buildrz."}
      </p>
      <p>
        {`Veuillez décrocher la case "Se connecter via un annuaire d'entreprise" et saisir votre mot de passe.`}
      </p>
    </>
  ),
  unknownSamlUser: (
    <>
      <p>{"Erreur : votre compte n'est pas reconnu dans Buildrz."}</p>
      <p>
        {'Veuillez nous contacter pour résoudre le problème : '}
        <a href="mailto:customer@buildrz.io">customer@buildrz.io</a>
      </p>
    </>
  ),
  disabledAccount: (
    <>
      <p>
        {
          'Erreur : Votre compte a été temporairement désactivé suite à des saisies répétées de mots de passe erronés.'
        }
      </p>
      <p>
        {"Contactez l'équipe Customer Success de Buildrz ("}
        <a href="mailto:customer@buildrz.io">customer@buildrz.io</a>
        {' ou 01 75 43 96 87) pour réactiver votre compte.'}
      </p>
    </>
  ),
};
